import { Component, OnInit } from '@angular/core';
import { Observable, of } from 'rxjs';
import { User } from 'src/app/admin/1.tv/models/user.model';
import { AppService } from 'src/app/app.service';
import { StripeResponseService } from 'src/app/services/stripe-response.service';

@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent implements OnInit {
  public isUserEmailVeried: string;
  public userId = '';
  public userImage: any;
  public userName: string;
  public userEmail: string;
  public user: Observable<User>;

  constructor(
    public appService: AppService,
    public stripeResponseService: StripeResponseService) {


    // stripeResponseService.returnMessageLoginPlus.subscribe((message) => {
    //   console.log("stripeResponseService UserMenuComponent", message);
    //   this.isUserEmailVeried = message.userData.emailVerified;
    //   this.userId = message.userData.id
    //   this.userImage = message.userData.image;
    //   this.userName = message.userData.displayName;
    //   this.userEmail = message.userData.email;

    // });

    // stripeResponseService.returnMessageLogoutPlus.subscribe((message) => {
    //   console.log("stripeResponseService.returnMessageLogoutPlus", message);
    //   this.userId = ''
    //   this.userImage = '';
    //   this.userName = '';
    //   this.userEmail = '';

    // });

  }

  ngOnInit() {

    this.user = of(this.stripeResponseService.currentLoggedInUser);

  }

}
